// Generated by ts-to-zod
import { z } from 'zod'

export const productSchema = z
  .object({
    Name: z.string(),
    Description: z.string(),
    Revenue: z.string()
  })
  .and(z.record(z.string()))

export const percentageMetricsSchema = z.object({
  TimePercentage: z.number(),
  VolumePercentage: z.number(),
  QualityPercentage: z.number(),
  SentimentPercentage: z.number(),
  CostPercentage: z.number(),
  RiskPercentage: z.number()
})

export const streamStageSchema = z
  .object({
    Name: z.string(),
    Description: z.string(),
    Percentage: z.number(),
    PercentageMetrics: percentageMetricsSchema.optional()
  })
  .and(z.record(z.union([z.string(), z.number(), z.any()])))

export const capabilitySchema = z
  .object({
    Name: z.string(),
    Stage: z.string(),
    AssessedBy: z.array(z.string()).optional(),
    Percentage: percentageMetricsSchema.optional()
  })
  .and(z.record(z.union([z.string(), z.array(z.string()), z.any()])))

export const capability2StreamStageSchema = z
  .object({
    'Lead Object': z.string(),
    'Member Object': z.string()
  })
  .and(z.record(z.string()))

export const team2CapabilitySchema = z
  .object({
    team: z.string(),
    capability: z.string(),
    stage: z.string().optional(),
    Territory: z.string(),
    Percentage: percentageMetricsSchema.optional()
  })
  .and(z.record(z.union([z.string(), z.any()])))

export const teamMappingSchema = z
  .object({
    ApplicationGroup: z.string(),
    Team: z.string(),
    Capability: z.string().optional(),
    Percentage: percentageMetricsSchema.optional()
  })
  .passthrough()

export const app2AppFlowSchema = z
  .object({
    'Lead Object Parent': z.string(), // source application group
    'Lead Object': z.string(), // source app
    'Member Object Parent': z.string(), // target application group
    'Member Object': z.string(), // target app
    Flow: z.string()
  })
  .and(z.record(z.string()))

export const leafNodeSchema = z
  .object({
    Leaf: z.string(),
    Application: z.string(),
    Stage: z.string(),
    Team: z.string(),
    Capability: z.string(),
    Products: z.array(z.string()),
    Type: z.string(),
    Percentage: percentageMetricsSchema
  })

export const graphDataSchema = z.object({
  products: z.array(productSchema),
  stages: z.array(streamStageSchema),
  capabilities: z.array(capabilitySchema),
  teams: z.array(team2CapabilitySchema),
  applicationGroups: z.array(teamMappingSchema),
  leafs: z.array(leafNodeSchema),
  flows: z.array(z.record(z.string()))
})
